import React from 'react'
import styles from './styles.module.scss'

type TextareaOnChange<T extends string> = (args: Record<T, string>) => void

type TextareaProps<T extends string> =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    id: T
    changeValue: TextareaOnChange<T>
  }

function Textarea<T extends string>({
  id,
  changeValue,
  ...props
}: TextareaProps<T>) {
  const onValueChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) =>
    changeValue({ [id]: e.target.value } as Record<T, string>)
  return (
    <textarea
      id={id}
      className={styles.form__textarea}
      onChange={onValueChanged}
      {...props}
    />
  )
}

export default Textarea
